import { Component, Input, View, OnInit } from 'angular2/core';
import { CORE_DIRECTIVES, DatePipe } from 'angular2/common';
import { Router, RouteParams } from 'angular2/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

import { Header } from '../layout/header/header';
import { Sidebar } from '../layout/sidebar/sidebar';
import { Event } from './event.model';
import { EventService } from './event.service';
import { Attendee } from '../attendee/attendee.model';
import { AlertService, AlertMessage, MessageType } from '../alert/alert.service';
import { Alert } from '../alert/alert';
import { CompanyService } from '../company/company.service';
import { Company } from '../company/company.model';

import { PaginatePipe } from '../pagination/paginate-pipe';
import { PaginationService } from '../pagination/pagination-service';
import { PaginationCmp } from '../pagination/pagination';
import { SortPipe } from '../sort/sort-pipe';
import { SortCmp } from '../sort/sort';
import { SortService } from '../sort/sort-service';

declare var UIkit: any;

let template = require('./event-view.html');

@Component({
  selector: 'event-view',
  providers: [PaginationService],
})
@View({
  pipes: [DatePipe, PaginatePipe, SortPipe],
  directives: [CORE_DIRECTIVES, Header, Sidebar, Alert, PaginationCmp, SortCmp],
  template: template,
})
export class EventView implements OnInit {
  event: Event = new Event();
  attendees: Attendee[] = [];
  requesters: Attendee[] = [];
  companies: Company[] = [];
  expanded: Object = null;
  @Input() inputSearch;

  constructor(
    public router: Router,
    public routeParams: RouteParams,
    private eventService: EventService,
    private companyService: CompanyService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.loadCompanies();
    let id = this.routeParams.get('id');
    if (id) {
      this.loadEvent(id);
    }
  }

  loadCompanies() {
    this.companyService.asCompanyList(
      this.companyService.list()).subscribe(
      companies => { this.companies = companies; });
  }

  loadEvent(id: string) {
    this.eventService.get(id).concatMap(event => {
      this.event = event;
      return Observable.forkJoin(
        this.eventService.getAttendees(event),
        this.eventService.getRequesters(event)
      );
    }).map((data) => {
      this.attendees = data[0];
      this.requesters = data[1];
    }).subscribe();
  }

  companyName(companyId: string): string {
    for (let company of this.companies) {
      if (company.id === companyId) {
        return company.name;
      }
    }
    return '';
  }

  toggleExpand(value: Object) {
    if (this.isExpanded(value)) {
      this.expanded = null;
      return;
    }
    this.expanded = value;
  }

  isExpanded(value: Object): boolean {
    return this.expanded === value;
  }

  edit($event, event) {
    $event.preventDefault();
    this.router.navigate(['/EventDetail', { id: event.id }]);
  }

  alert(text: string, type: MessageType) {
    this.alertService.push({ text, type });
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/event/event-view.ts
 **/